import cx from 'classnames';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import Button from './button';
import imessage from '../../images/icons/apple.svg';
import android from '../../images/icons/android.svg';
import { qr, or, ctaBlock } from './cta.module.scss';

// This needs to be set here since it drives the rendering of the qr.
// Match the CSS for best results.
const qrSize = 74;

export const CTAQRCode = ({ keyword }) => {
  return (
    <>
      <p>
        <span className={or}>or</span> text <strong>{keyword}</strong> to{' '}
        <strong>50409</strong>
      </p>

      <QRCode
        className={qr}
        size={qrSize}
        bgColor={'transparent'}
        value={`smsto:50409?&body=${encodeURIComponent(keyword)}`}
      />
    </>
  );
};

// Buttons that start a Resist.bot conversation right away
const ResistCTAButtons = ({
  className,
  keyword = 'resist',
  theme = 'blue',
}) => {
  return (
    <div className={cx(ctaBlock, className)}>
      <Button
        theme={theme}
        href={`https://bcrw.apple.com/sms:open?service=iMessage&recipient=urn:biz:d0189b65-f844-4344-adc1-d2d01daca04e&body=${keyword}`}
        iconSrc={imessage}
      >
        iMessage
      </Button>
      <Button
        theme={theme}
        href={`sms:50409?&body=${keyword}`}
        iconSrc={android}
      >
        Text
      </Button>
      <CTAQRCode keyword={keyword} />
    </div>
  );
};

CTAQRCode.propTypes = {
  keyword: PropTypes.string.isRequired,
};

ResistCTAButtons.propTypes = {
  className: PropTypes.string,
  keyword: PropTypes.string,
  theme: PropTypes.string,
};

export default ResistCTAButtons;
